
export const STORAGE_MENU_FAVORITES = 'menuFavorites_1678869299';
export const STORAGE_USER_AGENT = 'userAgent_1675441689';
export const STORAGE_LOCATION = 'userIPLocation_1676022236';
export const STORAGE_LANGUAGE = 'userLang_1644914409';
export const STORAGE_CHECKOUT_SESSION = 'checkoutSession_1682937957';